import { LitElement, css, html } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import { subSystems } from '../../config/system';
import getUrl from '../utils/getUrl';
import './ls-systems-button';
import './ls-dropdown-button';
import './ls-modal';
import { type RoleInfo } from '../types/leishan';

@customElement('ls-systems-sub-menu')
export class LsSystemsSubMenu extends LitElement {
    static styles = css`
        .ls-systems-button {
            display: flex;
            gap: 15px;
        }

        .ls-systems-sub-menu {
            border: 1px solid transparent;
            padding: 10px 15px;
            border-radius: 5px;
            transition: all 0.3s ease;
            position: relative;
        }
        .ls-systems-sub-menu.active {
            border-color: #333;
        }
    `;

    @state() isSubMenuActive: boolean = false;
    @state() isClicking: boolean = false;

    @property({ type: Object }) roleInfo: RoleInfo = {};

    private _handlerDropdownButtonClick(event: Event) {
        this.isClicking = true;
        this.isSubMenuActive = !this.isSubMenuActive;
        setTimeout(() => (this.isClicking = false), 0);
    }

    connectedCallback(): void {
        super.connectedCallback();
        const self = this as HTMLElement;
        document.addEventListener(
            'click',
            (event) => {
                if (this.isClicking) return;
                if (!(event.target instanceof HTMLElement)) return;
                if (self.contains(event.target)) return;
                this.isSubMenuActive = false;
            },
            { capture: false }
        );
    }

    render() {
        const gridIconUrl = getUrl(`assets/images/grid-icon.webp`);
        return html`<div class="ls-systems-sub-menu ${this.isSubMenuActive ? 'active' : ''}">
            <ls-dropdown-button .isActive=${this.isSubMenuActive} @click=${this._handlerDropdownButtonClick}>
                <img src=${gridIconUrl} width="20" height="20" alt="grid-icon" />
            </ls-dropdown-button>
            ${this.isSubMenuActive
                ? html`
                      <ls-modal align="right" .onClose=${() => (this.isSubMenuActive = false)}>
                          ${subSystems.map((system) => {
                              if (system.permission && !system.permission(this.roleInfo)) return;
                              return html`
                                  <ls-systems-button
                                      name=${system.name}
                                      uri=${system.uri}
                                      target=${system.target}
                                  ></ls-systems-button>
                              `;
                          })}
                      </ls-modal>
                  `
                : ''}
        </div>`;
    }
}
